import React from 'react';

import { FileIcon, defaultStyles } from 'react-file-icon';

import { IDefaultFilePreviewProps } from 'interfaces/File/file';

import { PrimaryButton } from '../../Button/PrimaryButton';

export default function DefaultFilePreview({
  fileResponse,
  url,
  mimetype,
}: IDefaultFilePreviewProps) {
  const fileExt = (fileResponse?.data.extension ||
    mimetype) as keyof typeof defaultStyles;
  const urlParams = fileResponse?.data.url.split('?')[1];
  const downloadable =
    !fileResponse?.data.settings || fileResponse?.data.settings?.downloadable;

  return (
    <div className="w-full h-full flex flex-col items-center">
      <div className="text-center m-auto ">
        {/* <img src={LogoSad.src} alt="File Not Supported" className="h-64 " /> */}
        <div className="w-32 m-auto">
          <FileIcon extension={fileExt} {...defaultStyles[fileExt]} />
        </div>
        <div className="mt-4 font-semibold text-xl">
          {fileResponse?.data.name}
        </div>
        {downloadable && !url && (
          <div className="items-center flex flex-row justify-center mt-6">
            <PrimaryButton
              onClick={() => {
                window.open(
                  `${process.env.NEXT_PUBLIC_API_URL}/content/${fileResponse.data.uuid}?${urlParams}&download=true`,
                  '_self'
                );
              }}
            >
              <span>Download File</span>
            </PrimaryButton>
          </div>
        )}
        {url && (
          <div className="items-center flex flex-row justify-center mt-6">
            <PrimaryButton
              onClick={() => {
                window.open(`${url}`, '_self');
              }}
            >
              <span>Download File</span>
            </PrimaryButton>
          </div>
        )}
      </div>
    </div>
  );
}
